import React from "react";
import { useNavigate } from "react-router-dom";
import "./UnauthorizedAccess.css"; // Make sure to import the CSS

const UnauthorizedAccess = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="unauthorized-container">
      <h1 className="unauthorized-title">Access Denied</h1>
      <p className="unauthorized-message">
        You are not authorized to access this page.
      </p>
      <button onClick={handleGoHome} className="unauthorized-button">
        Go Home
      </button>
    </div>
  );
};

export default UnauthorizedAccess;
